import DashboardServices from "@/services/DashboardServices";
import CustomerServices from "@/services/CustomerServices";

const types = {
  GET_BILLS: '@DASHBOARD/GET_BILLS',
  GET_BILLS_SERIES_LIST: '@DASHBOARD/GET_BILLS_SERIES_LIST',
  GET_PRODUCTS: '@DASHBOARD/GET_PRODUCTS',
  GET_PRODUCTS_SERIES_LIST: '@DASHBOARD/GET_PRODUCTS_SERIES_LIST',
  GET_CUSTOMERS_SALES: '@DASHBOARD/GET_CUSTOMERS_SALES',
  GET_CUSTOMER_LIST: '@DASHBOARD/GET_CUSTOMER_LIST',
  GET_BILL_MONTH: '@DASHBOARD/GET_BILL_MONTH',
  GET_PRODUCTS_MONTH: '@DASHBOARD/GET_PRODUCTS_MONTH',
  GET_SELECT_SALE_USER: '@DASHBOARD/GET_SELECT_SALE_USER',
  GET_BEFORE_USED_AMOUNT : '@DASHBOARD/GET_BEFORE_USED_AMOUNT',
  GET_CONTRACT_TOP: '@DASHBOARD/GET_CONTRACT_TOP',
  GET_PRODUCTS_TOP: '@DASHBOARD/GET_PRODUCTS_TOP',
  GET_CONTRACT_TOP_COUNT: '@DASHBOARD/GET_CONTRACT_TOP_COUNT',
  GET_PRODUCTS_TOP_COUNT: '@DASHBOARD/GET_PRODUCTS_TOP_COUNT',
  GET_NOTICES: '@DASHBOARD/GET_NOTICES',
  GET_SERVICEREQUEST_STATUS: '@DASHBOARD/GET_SERVICEREQUEST_STATUS',
}

export {
  types as dashboardTypes
}

export default {
  namespaced: true,
  state: {
    bills: [],
    billsSeriesList : [],
    products: [],
    productsSeriesList : [],
    salesList : [],
    customerList: [],
    billMonth: "-5",
    productsMonth: "-5",
    selectSaler: {},
    beforeUsedAmount: [],
    contractTop: [],
    productsTop: [],
    productsTopCount: 0,
    contractTopCount: 0,
    notices: [],
    serviceRequestStatus: {},
  },

  getters: {
    bills: (state) => {
      return state.bills
    },
    billsSeriesList: (state) => {
      return state.billsSeriesList
    },
    salesList: (state) => {
      return state.salesList
    },
    customerList: (state) => {
      return state.customerList
    },
    billMonth: (state) => {
      return state.billMonth
    },
    productsMonth: (state) => {
      return state.productsMonth
    },
    selectSaler: (state) => {
      return state.selectSaler
    },
    products: (state) => {
      return state.products
    },
    productsSeriesList: (state) => {
      return state.productsSeriesList
    },
    beforeUsedAmount: (state) => {
      return state.beforeUsedAmount
    },
    contractTop: (state) => {
      return state.contractTop
    },
    contractTopCount: (state) => {
      return state.contractTopCount
    },
    productsTop: (state) => {
      return state.productsTop
    },
    productsTopCount: (state) => {
      return state.productsTopCount
    },
    notices: (state) => {
      return state.notices
    },
    serviceRequestStatus: (state) => {
      return state.serviceRequestStatus
    }
  },

  mutations: {
    [types.GET_BILLS] (state, payload) {
      state.bills = payload.bills
    },
    [types.GET_BILLS_SERIES_LIST] (state, payload) {
      state.billsSeriesList = payload.billsSeriesList
    },
    [types.GET_CUSTOMERS_SALES] (state, payload) {
      state.salesList = payload.salesList
    },
    [types.GET_CUSTOMER_LIST] (state, payload) {
      state.customerList = payload.customerList
    },
    [types.GET_BILL_MONTH] (state, payload) {
      state.billMonth = payload.billMonth
    },
    [types.GET_PRODUCTS_MONTH] (state, payload) {
      state.productsMonth = payload.productsMonth
    },
    [types.GET_SELECT_SALE_USER] (state, payload) {
      state.selectSaler = payload.selectSaler
    },
    [types.GET_PRODUCTS] (state, payload) {
      state.products = payload.products
    },
    [types.GET_PRODUCTS_SERIES_LIST] (state, payload) {
      state.productsSeriesList = payload.productsSeriesList
    },
    [types.GET_BEFORE_USED_AMOUNT] (state, payload) {
      state.beforeUsedAmount = payload.beforeUsedAmount
    },
    [types.GET_CONTRACT_TOP] (state, payload) {
      state.contractTop = payload.contractTop
    },
    [types.GET_PRODUCTS_TOP] (state, payload) {
      state.productsTop = payload.productsTop
    },
    [types.GET_PRODUCTS_TOP_COUNT] (state, payload) {
      state.productsTopCount = payload.productsTopCount
    },
    [types.GET_CONTRACT_TOP_COUNT] (state, payload) {
      state.contractTopCount = payload.contractTopCount
    },
    [types.GET_NOTICES] (state, payload) {
      state.notices = payload.notices
    },
    [types.GET_SERVICEREQUEST_STATUS] (state, payload) {
      state.serviceRequestStatus = payload.serviceRequestStatus
    }

  },
  actions: {
    async getBillChartData ({ commit }, payload) {
      const { empNo, startMonth, endMonth, customerDepts } = payload
      const response = await DashboardServices.getBillChartData({
        empNo, startMonth, endMonth, customerDepts
      })
      commit(types.GET_BILLS, { bills: response.data.resultData.chartData })
      commit(types.GET_BILLS_SERIES_LIST, { billsSeriesList: response.data.resultData.chartFilter })
      return response.data.resultData
    },
    async getProductChartData ({ commit }, payload) {
      const { empNo, startMonth, endMonth, customerDepts } = payload
      const response = await DashboardServices.getProductChartData({
        empNo, startMonth, endMonth, customerDepts
      })
      commit(types.GET_PRODUCTS, { products: response.data.resultData.chartData })
      commit(types.GET_PRODUCTS_SERIES_LIST, { productsSeriesList: response.data.resultData.chartFilter })
      return response.data.resultData
    },
    async getCustomersSales ({ commit }) {
      const response = await CustomerServices.getCustomersSales()
      commit(types.GET_CUSTOMERS_SALES, { salesList: response.data.resultData })
      return response.data.resultData
    },
    async getCustomerPersoninChargeWithUseremail ({ commit }, email) {
      const response = await CustomerServices.getCustomerPersoninChargeWithUseremail(email)
      commit(types.GET_CUSTOMER_LIST, { customerList: response.data.resultData })
      return response.data.resultData
    },
    async getCustomers ({ commit }, email) {
      const response = await CustomerServices.getCustomers(email)
      commit(types.GET_CUSTOMER_LIST, { customerList: response.data.resultData })
      return response.data.resultData
    },
    setBillMonth({commit}, billMonth){
      commit(types.GET_BILL_MONTH, { billMonth: billMonth})
    },
    setProductsMonth({commit}, productsMonth){
      commit(types.GET_PRODUCTS_MONTH, { productsMonth: productsMonth})
    },
    setSelectSalesUser({commit}, selectSaler){
      commit(types.GET_SELECT_SALE_USER, { selectSaler: selectSaler})
    },
    async getBeforeMonthUsedAmount ({ commit }, payload) {
      commit(types.GET_BEFORE_USED_AMOUNT, { beforeUsedAmount: [] })
      const { empNo, customerDepts } = payload
      const response = await DashboardServices.getBeforeMonthUsedAmount({
        empNo, customerDepts
      })
      commit(types.GET_BEFORE_USED_AMOUNT, { beforeUsedAmount: response.data.resultData })
      return response.data.resultData
    },
    async selectBeforeMonthContractTop ({ commit }, payload) {
      const { empNo, customerDepts } = payload
      const response = await DashboardServices.selectBeforeMonthContractTop({
        empNo, customerDepts
      })
      commit(types.GET_CONTRACT_TOP, { contractTop: response.data.resultData.data })
      commit(types.GET_CONTRACT_TOP_COUNT, { contractTopCount: response.data.resultData.count })
      return response.data.resultData
    },
    async selectBeforeMonthProductsTop ({ commit }, payload) {
      const { empNo, customerDepts } = payload
      const response = await DashboardServices.selectBeforeMonthProductsTop({
        empNo, customerDepts
      })
      commit(types.GET_PRODUCTS_TOP, { productsTop: response.data.resultData.data })
      commit(types.GET_PRODUCTS_TOP_COUNT, { productsTopCount: response.data.resultData.count })
      return response.data.resultData
    },
    async selectNoticeList({commit}, payload){
      commit(types.GET_NOTICES, { notices: [] })
      const { pageNo, size, searchText } = payload
      const response = await DashboardServices.getNotices({
        pageNo, size, searchText
      })
      commit(types.GET_NOTICES, { notices: response.data.resultData.notice })
      return response.data.resultData
    },
    async selectServiceRequestStatus({commit}, payload){
      const { empNo, startDate, endDate, customerDepts } = payload
      const response = await DashboardServices.getServiceRequestSatus({
        empNo, startDate, endDate, customerDepts
      })

      if(!!response.data.resultData){
        const servicerequestSize = response.data.resultData.serviceRequests.length
        if(servicerequestSize < 5){
          for(let i =0; i < 5 - servicerequestSize; i++){
            response.data.resultData.serviceRequests.push({
              id: '',
              receiveDate: '',
              subject: '',
              division: ''
            })
          }
        }

      }

      commit(types.GET_SERVICEREQUEST_STATUS, { serviceRequestStatus: response.data.resultData })
      return response.data.resultData
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js